

<app-landing-page *ngIf="!userIsLogged"></app-landing-page>

<app-common-page *ngIf="userIsLogged"></app-common-page>



